var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnablePayouts75ProgressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9367,
    cy: 32.3313,
    r: 31.9446,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2837 44.7829H24.7004C20.3254 44.7829 17.4087 42.5954 17.4087 37.4912V27.2829C17.4087 22.1787 20.3254 19.9912 24.7004 19.9912H39.2837C43.6587 19.9912 46.5754 22.1787 46.5754 27.2829V37.4912C46.5754 42.5954 43.6587 44.7829 39.2837 44.7829Z",
    stroke: "#1E247E",
    strokeWidth: 2.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9922 36.7617C34.4084 36.7617 36.3672 34.803 36.3672 32.3867C36.3672 29.9705 34.4084 28.0117 31.9922 28.0117C29.5759 28.0117 27.6172 29.9705 27.6172 32.3867C27.6172 34.803 29.5759 36.7617 31.9922 36.7617Z",
    fill: "#DA867D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4087 28.0114H18.867C23.242 28.0114 24.7004 26.5531 24.7004 22.1781V20.7197",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5754 28.0114H45.117C40.742 28.0114 39.2837 26.5531 39.2837 22.1781V20.7197",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4087 36.7617H18.867C23.242 36.7617 24.7004 38.2201 24.7004 42.5951V44.0534",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5754 36.7617H45.117C40.742 36.7617 39.2837 38.2201 39.2837 42.5951V44.0534",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9922 34.3867C33.0968 34.3867 33.9922 33.4913 33.9922 32.3867C33.9922 31.2821 33.0968 30.3867 31.9922 30.3867C30.8876 30.3867 29.9922 31.2821 29.9922 32.3867C29.9922 33.4913 30.8876 34.3867 31.9922 34.3867Z",
    fill: "#F0C330"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_27407_25352",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0477 0.441872C38.3657 0.452847 44.5386 2.33709 49.7857 5.85632C55.0329 9.37556 59.1186 14.3717 61.5263 20.213C63.934 26.0543 64.5554 32.4784 63.3121 38.6729C62.0687 44.8674 59.0164 50.554 54.5411 55.0138C50.0658 59.4736 44.3686 62.5061 38.1698 63.7279C31.9711 64.9497 25.5492 64.306 19.7163 61.878C13.8834 59.4501 8.90145 55.347 5.40047 50.0877C1.89949 44.8283 0.0367048 38.6489 0.0476803 32.3309L2.26023 32.3347C2.25001 38.2152 3.98378 43.9666 7.24227 48.8616C10.5008 53.7567 15.1376 57.5756 20.5665 59.8354C25.9954 62.0951 31.9725 62.6943 37.7419 61.5571C43.5114 60.4199 48.814 57.5974 52.9793 53.4466C57.1446 49.2957 59.9855 44.0029 61.1428 38.2375C62.3 32.472 61.7216 26.4929 59.4807 21.0562C57.2398 15.6195 53.437 10.9693 48.5533 7.69385C43.6696 4.41837 37.9243 2.66464 32.0438 2.65442L32.0477 0.441872Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0477 0.441872C38.3657 0.452847 44.5386 2.33709 49.7857 5.85632C55.0329 9.37556 59.1186 14.3717 61.5263 20.213C63.934 26.0543 64.5554 32.4784 63.3121 38.6729C62.0687 44.8674 59.0164 50.554 54.5411 55.0138C50.0658 59.4736 44.3686 62.5061 38.1698 63.7279C31.9711 64.9497 25.5492 64.306 19.7163 61.878C13.8834 59.4501 8.90145 55.347 5.40047 50.0877C1.89949 44.8283 0.0367048 38.6489 0.0476803 32.3309L2.26023 32.3347C2.25001 38.2152 3.98378 43.9666 7.24227 48.8616C10.5008 53.7567 15.1376 57.5756 20.5665 59.8354C25.9954 62.0951 31.9725 62.6943 37.7419 61.5571C43.5114 60.4199 48.814 57.5974 52.9793 53.4466C57.1446 49.2957 59.9855 44.0029 61.1428 38.2375C62.3 32.472 61.7216 26.4929 59.4807 21.0562C57.2398 15.6195 53.437 10.9693 48.5533 7.69385C43.6696 4.41837 37.9243 2.66464 32.0438 2.65442L32.0477 0.441872Z",
    stroke: "#3876BB",
    strokeWidth: 8,
    mask: "url(#path-9-inside-1_27407_25352)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnablePayouts75ProgressIcon);
export default __webpack_public_path__ + "static/media/EnablePayouts75ProgressIcon.f91a76c8be6ada6b86e17e1422166be5.svg";
export { ForwardRef as ReactComponent };